/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Paste_TextInputs */

const en_import_paste_text = /** @type {(inputs: Import_Paste_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste text`)
};

const de_import_paste_text = /** @type {(inputs: Import_Paste_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text einfügen`)
};

/**
* | output |
* | --- |
* | "Paste text" |
*
* @param {Import_Paste_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_paste_text = /** @type {((inputs?: Import_Paste_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Paste_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_paste_text(inputs)
	return en_import_paste_text(inputs)
});